import { render } from "./CardItem.vue?vue&type=template&id=cf75da64&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=cf75da64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cf75da64"

export default script